import { jourDeTunis } from './employes.js';

/**
 * Exports Excel (docs/API.md § Exports) : formats communs à l'API, qui écrit
 * les classeurs, et à l'écran, qui affiche les mêmes valeurs.
 */
export const TYPE_XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

/** Source d'une candidature en français ; un code inconnu est rendu tel quel. */
export const LIBELLES_SOURCE: Record<string, string> = {
  tanitjobs: 'Tanitjobs',
  tunisietravail: 'Tunisie Travail',
  keejob: 'Keejob',
  direct: 'Candidature directe',
  transfert: 'Transfert',
  vivier: 'Vivier',
  formulaire: 'Formulaire public',
  whatsapp: 'WhatsApp',
};

export function libelleSource(source: string): string {
  return LIBELLES_SOURCE[source] ?? source;
}

export function nomComplet(personne: { prenom: string | null; nom: string | null; anonymisee?: boolean }): string {
  if (personne.anonymisee) return 'Profil anonymisé';
  return [personne.prenom, personne.nom].filter(Boolean).join(' ') || 'Sans nom';
}

const FORMAT_TUNIS = new Intl.DateTimeFormat('fr-FR', {
  timeZone: 'Africa/Tunis',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

function morceaux(valeur: string | null | undefined): Record<string, string> | null {
  if (!valeur) return null;
  const date = new Date(valeur);
  if (Number.isNaN(date.getTime())) return null;
  return Object.fromEntries(FORMAT_TUNIS.formatToParts(date).map((p) => [p.type, p.value]));
}

/**
 * `JJ/MM/AAAA` à l'heure de Tunis, quel que soit le fuseau du poste ou du
 * serveur. Un jour seul (`AAAA-MM-JJ`) n'a pas d'heure : il est repris tel quel.
 */
export function dateTunis(valeur: string | null | undefined): string | null {
  if (valeur && /^\d{4}-\d{2}-\d{2}$/.test(valeur)) return valeur.split('-').reverse().join('/');
  const p = morceaux(valeur);
  return p ? `${p.day}/${p.month}/${p.year}` : null;
}

/** `JJ/MM/AAAA HH:MM` à l'heure de Tunis. */
export function dateHeureTunis(valeur: string | null | undefined): string | null {
  const p = morceaux(valeur);
  return p ? `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}` : null;
}

/** `rh-candidats-PG-VTE-260913-001-2026-09-15.xlsx` : sans accent, espace ni caractère piège. */
export function nomFichierExport(
  sujet: string,
  maintenant: Date = new Date(),
  extension: 'xlsx' | 'pdf' = 'xlsx',
): string {
  const propre = sujet
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
    .replace(/-+$/, '');
  return `rh-${propre || 'export'}-${jourDeTunis(maintenant)}.${extension}`;
}
